{
  "es": {
    "proposal": {
      "actions": {
        "addDescription": "Añadir descripción",
        "addDocuments": "Añadir documentos",
        "addSubchoiceList": "Añadir lista de subopciones",
        "addSubchoices": "Añadir subopción",
        "approve": "Aceptar",
        "cancel": "Cancelar",
        "choice": {
          "collapse": "Contraer opciones",
          "delete": "Eliminar opción",
          "edit": "Editar opción",
          "expand": "Expandir opciones"
        },
        "choice_list": {
          "delete": "Eliminar lista de opciones"
        },
        "createNew": "Nueva propuesta",
        "deleteDescription": "Eliminar descripción",
        "deleteDocuments": "Eliminar documentos",
        "delete_documents": "Eliminar documento | Eliminar documentos",
        "delete_proposal": "Eliminar propuesta",
        "delete_proposal_templates": "Eliminar plantilla de propuesta",
        "dontShare": "Aún no hace falta compartir",
        "duplicate": "Duplicar",
        "edit": "Editar",
        "generatePDF": "Generar PDF",
        "new": "Propuesta",
        "newProposalCustomer": "Nueva propuesta",
        "publish": "Publicar",
        "reject": "Deshacer aprobación",
        "save": "Guardar",
        "share": "Compartir",
        "shareWithProjectPartners": "Compartir documentos con los colaboradores del proyecto...",
        "share_units": "Compartir con unidades",
        "signAndApprove": "Firmar y aprobar propuesta",
        "signElectronically": "O firmar electrónicamente en su lugar",
        "steps": {
          "collapse": "Contraer pasos",
          "expand": "Expandir pasos"
        },
        "stop_template_sync": "Detener sincronización con la plantilla",
        "submit": "Guardar",
        "uploadAndApprove": "Subir y aprobar propuesta",
        "uploadSignableDocument": "Subir documento firmado para la aprobación"
      },
      "attributes": {
        "amount_gross": "Oferta bruta",
        "amount_net": "Oferta neta",
        "choice_lists": {
          "description": "Descripción",
          "name": "Nombre"
        },
        "choices": {
          "description": "Descripción",
          "images": "Imágenes",
          "name": "Nombre",
          "price_gross": "Precio bruto del artículo",
          "price_net": "Precio neto del artículo",
          "quantity": "Cantidad",
          "quantity_fixed": "Cantidad fija",
          "quantity_max": "Máximo",
          "quantity_min": "Mínimo",
          "quantity_not_fixed": "Dejar que el cliente indique la cantidad",
          "selected_default": "Siempre seleccionada",
          "total_price_gross": "Total bruto",
          "total_price_net": "Total neto"
        },
        "description": "¿Cómo describirías esta propuesta?",
        "documents": "Añadir documentos",
        "name": "Nombre",
        "subtitle": "Esto facilita que otros se refieran a ella",
        "title": "Ponle un título a tu propuesta",
        "type": {
          "choices": "Lista de opciones",
          "fixed": "Oferta fija"
        },
        "vat_percentage": "% de IVA"
      },
      "labels": {
        "accepted": "Aceptada",
        "addExtraBudget": "Añadir presupuesto adicional",
        "allUnitsShared": "Esta plantilla ya está compartida con todas las unidades",
        "already_approved": "Esta propuesta ya ha sido aprobada.",
        "amount_net_total": "Total oferta neta",
        "amount_total": "Total oferta bruta",
        "approval_feedback": {
          "label": "Comentario (opcional)",
          "placeholder": "Comparte cualquier pregunta, condición o contexto adicional con el equipo."
        },
        "approve": "Aprobar {name}",
        "approved": "Aprobada",
        "approvedDate": "Aprobada {date}",
        "ask_client_to_undo": "No puedes editar una propuesta aprobada. Contacta con {client} para deshacer primero la aprobación.",
        "batchProposalsTemplate": "<p>Esta propuesta se creará para {units_count} unidad(es).</p></br><p>Como esta propuesta se creará para varias unidades, hemos creado una plantilla a partir de ella. Puedes encontrar esta plantilla en la pestaña 'Plantillas de propuestas'.</p></br><p>Las plantillas facilitan editar o eliminar todas las propuestas compartidas con esta plantilla.</p>",
        "batchProposalsWarning": "Esta propuesta se creará para {units_count} unidades. Si necesitas hacer cambios más tarde, tendrás que editar cada una por separado.",
        "budget": "Presupuesto",
        "builder": {
          "can_select_multiple": "Se pueden seleccionar varias",
          "item": "Añadir opción",
          "multiple_choices_possible": "Se permiten varias opciones",
          "must_choose_item": "Debe elegir una opción",
          "options": "Opciones",
          "section": "Lista de opciones",
          "step": "Paso",
          "step_basic": "Información básica",
          "step_details": "Detalles",
          "step_documents": "Documentos",
          "step_internal": "Información interna",
          "step_visibility": "Compartir con"
        },
        "by": "por",
        "choice_lists": {
          "add_another": "Añadir otra lista de opciones",
          "create": "Crear listas de opciones de la propuesta",
          "empty_help": "Empieza añadiendo tu(s) primera(s) lista(s) de opciones. Las listas de opciones agrupan opciones para un elemento concreto, p. ej. \"baldosas\". Después de añadir listas de opciones, puedes añadir una o varias opciones.",
          "selected": "Seleccionada"
        },
        "choices": {
          "add_another": "Añadir otra opción",
          "create": "Añadir opciones a {choiceListName}",
          "optional": "opcional",
          "selected_default": "Esta opción estará siempre seleccionada y su precio se calculará automáticamente en el precio total. El cliente no podrá deseleccionar esta opción.",
          "selected_default_tooltip": "Esta opción se incluye siempre y su precio se calcula automáticamente en el total.",
          "subtotal": "Subtotal"
        },
        "clickToChangeVisibility": "Haz clic para cambiar la visibilidad",
        "closed": "Esta decisión ya está cerrada. Ya no puedes aprobar una propuesta.",
        "createProposal": "Crear propuesta",
        "createProposals": "Crear propuesta",
        "created": "Creada",
        "createdBy": "Creada por {uploader}",
        "customer": "Cliente",
        "customerHasNotSelectedYet": "El cliente aún no ha seleccionado",
        "customer_name_confirm": "Escribe <i><b>{customerName}</b></i> para aceptar esta propuesta.",
        "customer_name_proceed": "Escribe <i><b>{customerName}</b></i> para continuar.",
        "customer_offer": "Oferta del cliente",
        "customers": "Clientes",
        "decision_not_interested": "La decisión está marcada como 'No interesado'.",
        "definedPerUnit": "Definido por unidad",
        "delete_proposal_template": "<p>Si eliminas esta plantilla, también se eliminarán todas las propuestas sincronizadas.<br>Si no quieres que esto ocurra, usa el interruptor de abajo.</p>",
        "depends_on_customer_input": "Depende de lo que indique el cliente",
        "documentsRequireSignature": "El cliente necesita firmar documentos",
        "documents_shared_partners": "Solo se comparten con los colaboradores del proyecto los documentos de la propuesta.",
        "duplicating": "Duplicando",
        "edit": "Editar",
        "editNotAllowed": "No se permite editar ni eliminar una propuesta aprobada. Deshaz primero la aprobación antes de editar.",
        "editProposal": "Editar propuesta",
        "excl%VAT": "IVA excl. {vat}%",
        "exclVAT": "IVA excl.",
        "export_documents": "Exportar documentos",
        "extraBudget": "Presupuesto adicional",
        "fractions_sent_count_header": "¡No se puede crear la propuesta!",
        "fractions_sent_count_message": "Ya se han enviado cuotas basadas en esta decisión. Cambia primero estas cuotas a borrador para continuar.",
        "full_prices": "Usa precios completos. Ziggu generará automáticamente las mejoras según el presupuesto de las decisiones",
        "generatingPDF": "Generando PDF",
        "has_requested_changes": "Esta propuesta ya tiene una solicitud de cambios pendiente.",
        "hideDetails": "Ocultar detalles",
        "installments_connected": "Hay cuotas vinculadas a esta propuesta.",
        "internalNote": "Nota interna",
        "internalNoteSubtitle": "Esta nota solo es visible para ti y tu equipo.",
        "internal_info": "Información interna",
        "keepHidden": "Mantener oculta",
        "keep_synced_proposals": "Mantén las propuestas sincronizadas para que se conviertan en una propuesta independiente.",
        "link_to_template": "¿Vincular a la plantilla?",
        "link_to_template_after_create": "Vincula inmediatamente esta propuesta a la nueva plantilla tras crearla.",
        "makeDecision": "Acepta una propuesta para {decision_name} haciendo clic en el botón de aprobar",
        "margin": "Margen",
        "marginBudget%": "Presupuesto de margen ({margin}%)",
        "marginSurcharge%": "Margen de mejoras ({margin}%)",
        "marginSurchargesExtraBudget%": "Margen de presupuesto adicional + mejoras ({margin}%)",
        "new": "Nueva propuesta",
        "noImage": "Sin imagen",
        "no_budget_available_yet": "No aplicable",
        "no_documents": "La propuesta no contiene ningún documento.",
        "no_edit_details": "Esta propuesta tiene elementos que dependen de ella. Contacta con el cliente si quieres editar los detalles",
        "no_edit_details_installments": "Esta propuesta tiene al menos una cuota facturada o pagada. Para editar los detalles de la propuesta, primero debes cambiar el estado de esta cuota a 'Prevista'. Ve a {link}.",
        "no_edit_details_installments_link": "finanzas",
        "no_edit_documents": "Cuando una propuesta está aprobada, los documentos no se pueden editar.",
        "notApplicable": "No aplicable",
        "notDefined": "No definido",
        "notSeenYetByCustomer": "Aún no vista por el cliente",
        "notSelectedYet": "Selecciona tus opciones para ver el total",
        "notSharedYet": "Aún no compartida",
        "not_approved_yet": "Esta propuesta aún no está aprobada.",
        "not_interested_reset_header": "Decisión marcada como 'No interesado'",
        "not_interested_reset_message": "Esta decisión está marcada actualmente como 'No interesado'. Crear una propuesta restablecerá el estado 'No interesado'.",
        "only_visible_team_partners": "Solo visible para el equipo",
        "other": "Otro",
        "proposalFor": "Propuesta para",
        "proposal_template_sync_note": "Los cambios en una plantilla de propuesta actualizan todas las propuestas sincronizadas (no aprobadas).",
        "proposal_unapprove_not_possible": "No se puede deshacer la aprobación",
        "proposalsApproved": "Propuestas aprobadas",
        "proposalsOther": "Otras propuestas",
        "relaunch": "Relanzar propuesta",
        "request_changes": {
          "body": "Indica qué es lo que hay que cambiar en esta propuesta",
          "feedback": "Comentarios",
          "title": "Solicitar cambios"
        },
        "requested_changes": "Cambios solicitados",
        "requiresSignature": "Necesita firmar documentos",
        "seenByCustomer": "Vista por el cliente:",
        "selectUnitsShare": "Selecciona las unidades con las que compartir la plantilla",
        "shareCustomerDescription": "Esta propuesta está vinculada a una decisión que aún no se ha compartido con el cliente. ¿Quieres compartir también la decisión para que el cliente pueda ver esta propuesta de inmediato?",
        "shareCustomerTitle": "¿Compartir la decisión con el cliente?",
        "shareDecision": "Compartir decisión",
        "shareExtraAlert": "La decisión también se compartirá en cuanto hagas clic en enviar",
        "sharePartnerTitle": "¿Compartir la decisión con el colaborador?",
        "sharePartnersDescription": "Esta propuesta está vinculada a una decisión que aún no se ha compartido con el colaborador. ¿Quieres compartir también la decisión para que el colaborador pueda ver esta propuesta de inmediato?",
        "sharedWith": "Compartido con",
        "showAndEditDetails": "Mostrar y editar detalles",
        "single_approval_warning": {
          "message": "Contacta con Ziggu para activar la aprobación de varias propuestas.",
          "title": "Puedes seguir creando propuestas, pero el cliente solo podrá aprobar una."
        },
        "skip_customer": "El proyecto omite el paso del cliente.",
        "surcharges": "Mejoras",
        "surcharges_extra": "Mejoras adicionales",
        "synced_with_template": "Sincronizada con la plantilla de propuesta",
        "synced_with_units": "Sincronizada con 1 unidad | Sincronizada con {unit_count} unidades",
        "template_accept_confirm": "<p>Esta propuesta está sincronizada con una plantilla de propuesta. Al aceptar esta propuesta, la sincronización se detendrá y esta propuesta ya no se actualizará cuando se actualice la plantilla.</p></br><p>¿Seguro que quieres aceptar esta propuesta?</p>",
        "template_edit_confirm": "<p>Esta propuesta está sincronizada con una plantilla de propuesta. Al editar esta propuesta, la sincronización se detendrá y esta propuesta ya no se actualizará cuando se actualice la plantilla.</p></br><p>¿Seguro que quieres seguir editando esta propuesta?</p>",
        "totalBudget": "Presupuesto total",
        "totalNetOffer": "Oferta neta",
        "total_excl_vat": "Total sin IVA",
        "total_incl_vat": "Total con IVA",
        "total_vat": "IVA total",
        "typeToShare": "Tipo de propuesta a compartir",
        "unit_not_activated": "La unidad no está activada.",
        "uploadDocuments": "Subir documentos firmados",
        "uploadSignedDocument": "O sube un documento firmado en su lugar",
        "vat_excl": "IVA excl.",
        "vat_excl_with_number": "IVA excl. {vat}%",
        "visibleForCustomer": "Visible para el cliente",
        "writeEmployeeNameAccept": "Escribe <i><b>{employeeName}</b></i> para aceptar esta propuesta.",
        "writeEmployeeNameDelete": "Escribe <i><b>{employeeName}</b></i> para eliminar esta propuesta.",
        "writeEmployeeNameReject": "Escribe <i><b>{employeeName}</b></i> para deshacer la aprobación de esta propuesta."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Pronto encontrarás aquí una propuesta para aprobar",
            "title": "Aún no hay propuestas para la decisión {decision_name}"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Propón una o varias ofertas y deja que decida tu cliente.",
            "title": "Crea una propuesta"
          },
          "proposalNotice": "Importante: solo se puede aprobar 1 propuesta. Siempre puedes editar una propuesta existente y añadir nuevos documentos.",
          "template": {
            "subtitle": "Cuando crees propuestas en lote, aparecerán aquí",
            "title": "Aún no se ha creado ninguna plantilla de propuesta."
          }
        },
        "partners": {
          "new": {
            "subtitle": "Propón una o varias ofertas y deja que decida el cliente.",
            "title": "Crea una propuesta"
          },
          "proposalNotice": "Importante: solo se puede aprobar 1 propuesta. Siempre puedes editar una propuesta existente y añadir nuevos documentos. Si una propuesta ya ha sido aprobada, un miembro del equipo puede deshacerla antes de añadir documentos adicionales."
        }
      },
      "toasts": {
        "convert": "Propuesta convertida en plantilla correctamente",
        "create": "Propuesta creada correctamente",
        "delete": "Propuesta eliminada correctamente",
        "shareSuccess": "Propuestas compartidas correctamente",
        "update": "Propuesta actualizada correctamente"
      },
      "validation": {
        "amountNotUpdatable": "El importe no se puede actualizar: hay cuotas que dependen de él",
        "choice_list": {
          "needChoice": "Esta lista de opciones necesita al menos 1 opción",
          "needSelection": "Esta opción requiere un elemento seleccionado"
        },
        "choices": {
          "lessThanOrEqual": "El número debe ser menor o igual que {max_number}",
          "needPriceItem": "El precio por artículo es obligatorio",
          "needSelection": "Se requiere seleccionar una opción",
          "needVatPercentage": "El porcentaje de IVA es obligatorio",
          "quantityBetween": "La cantidad debe estar entre {quantity_min} y {quantity_max}",
          "quantityNotZero": "La cantidad debe ser al menos 1",
          "quantityRequired": "La cantidad es obligatoria",
          "uniqueNames": "Los nombres deben ser únicos"
        },
        "nameNotCorrect": "El nombre es obligatorio y debe coincidir",
        "needName": "El título es obligatorio",
        "needNumber": "Debe ser un número (p. ej. 85)",
        "need_request_changes_note": "Indica el motivo de tu solicitud de cambios",
        "readAllDocuments": "Asegúrate de haber leído todos los documentos",
        "requiresSignature": "Marca al menos 1 documento en el que el cliente deba firmar electrónicamente. Desactiva el interruptor de abajo si no necesitas firmas.",
        "share": {
          "needSelection": "Selecciona con quién compartir la propuesta | Selecciona con quién compartir las propuestas",
          "needType": "Selecciona el/los tipo(s) de propuesta"
        },
        "uploadAtLeast1Document": "Sube al menos 1 documento firmado"
      }
    }
  }
}
